import { render } from "./vulnerability-info.vue?vue&type=template&id=78fdc8fc&scoped=true&ts=true"
import script from "./vulnerability-info.vue?vue&type=script&lang=ts"
export * from "./vulnerability-info.vue?vue&type=script&lang=ts"

import "./vulnerability-info.vue?vue&type=style&index=0&id=78fdc8fc&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fdc8fc"]])

export default __exports__